<template>
  <div v-if="isVisible" class="location-alert-container">
    <div class="location-alert">
      <svg
        class="alert-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm0 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
        />
      </svg>
      <div class="alert-content">
        <h4 class="alert-title">Location Not Enabled</h4>
        <p class="alert-message">
          To allow "Use My Location", enable location access in your browser
          settings.
        </p>
      </div>
      <button class="alert-close" @click="dismiss" aria-label="Close alert">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationAlert",
  data() {
    return {
      isVisible: false,
      timeoutId: null,
    };
  },
  methods: {
    show() {
      this.isVisible = true;

      // Clear any existing timeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      // Auto-dismiss after 7 seconds
      this.timeoutId = setTimeout(() => {
        this.isVisible = false;
      }, 7000);
    },
    dismiss() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.isVisible = false;
    },
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
};
</script>

<style scoped>
.location-alert-container {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.location-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%);
  border: 2px solid #ffc107;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
  max-width: 500px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

.alert-icon {
  width: 24px;
  height: 24px;
  color: #ff9800;
  flex-shrink: 0;
  margin-top: 2px;
}

.alert-content {
  flex: 1;
}

.alert-title {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #d84315;
}

.alert-message {
  margin: 0;
  font-size: 14px;
  color: #5d4037;
  line-height: 1.4;
}

.alert-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff9800;
  flex-shrink: 0;
  transition: opacity 0.2s;
}

.alert-close:hover {
  opacity: 0.7;
}

.alert-close svg {
  width: 20px;
  height: 20px;
}

@media (min-width: 601px) {
  .location-alert {
    max-width: 625px;
    padding: 25px 25px;
  }

  .alert-message {
    font-size: 17.5px;
  }
}

@media (max-width: 600px) {
  .location-alert-container {
    left: 10px;
    right: 10px;
    transform: translateX(0);
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .location-alert {
    flex-direction: column;
    max-width: 100%;
    position: relative;
    padding-right: 40px;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 160px;
  }

  .alert-icon {
    align-self: flex-start;
  }

  .alert-close {
    position: absolute;
    top: 12px;
    right: 12px;
  }
}
</style>
